import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Dialog, Modal, ModalOverlay } from "react-aria-components";

interface AnimatedProps {
  animated: boolean;
}

const overlayAnimation = css`
  &[data-entering] {
    animation: custom-overlay-fade-in var(--ease-time, 300ms) ease forwards;
  }

  &[data-exiting] {
    animation: custom-overlay-fade-out var(--ease-time, 300ms) ease forwards;
  }

  @keyframes custom-overlay-fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes custom-overlay-fade-out {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

const modalAnimation = css`
  &[data-entering] {
    animation: custom-modal-fade-in var(--ease-time, 300ms) ease forwards;
  }

  &[data-exiting] {
    animation: custom-modal-fade-out var(--ease-time, 300ms) ease forwards;
  }

  @keyframes custom-modal-fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes custom-modal-fade-out {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

const StyledModalOverlay = styled(ModalOverlay)<AnimatedProps>`
  label: CustomStyledModalOverlay;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  background-color: var(--color-charcoal-60);

  ${({ animated }) => animated && overlayAnimation}
`;

const StyledModal = styled(Modal)<AnimatedProps>`
  label: CustomStyledModal;
  --popup-dialog-width: 342px;
  flex: 0 0 auto;
  width: var(--popup-dialog-width);
  border-radius: 24px;
  background-color: var(--color-white);
  padding: 0;
  text-align: left;
  font-family: var(--font-family);
  font-feature-settings:
    "liga" off,
    "clig" off;

  ${({ animated }) => animated && modalAnimation}
`;

const StyledDialog = styled(Dialog)`
  label: StyledDialog;
  position: relative;
`;

export const CustomDialogStyled = {
  StyledModalOverlay,
  StyledModal,
  StyledDialog
};
